<template>
  <div class="profile-page">
    <div class="page-container">
      <div class="user-center">
        <user-center-sidebar active="profile" :user-info="userInfo"></user-center-sidebar>

        <section class="user-main">
          <!-- 用户信息卡片 -->
          <div class="user-hero">
            <div class="hero-avatar">{{ avatarInitial }}</div>
            <div class="hero-info">
              <div class="hero-line">
                <span class="greeting">{{ greeting }}</span>
                <span class="name">{{ displayName }}！</span>
              </div>
              <div class="hero-meta">
                <span><i class="el-icon-mobile-phone"></i> {{ userInfo.mobile || '--' }}</span>
                <span><i class="el-icon-message"></i> {{ userInfo.email || '--' }}</span>
                <span><i class="el-icon-office-building"></i> {{ userInfo.companyName || '--' }}</span>
                <span><i class="el-icon-time"></i> 注册于 {{ formatTime(userInfo.createTime) }}</span>
              </div>
            </div>
          </div>

      <!-- 数据统计 -->
      <div class="stats-grid">
        <div class="stat-card" @click="$router.push('/profile')">
          <div class="stat-icon"><i class="el-icon-time"></i></div>
          <div class="stat-num">{{ daysCount }}</div>
          <div class="stat-label">注册天数</div>
        </div>
        <div class="stat-card" @click="$router.push('/favorites')">
          <div class="stat-icon"><i class="el-icon-star-on"></i></div>
          <div class="stat-num">{{ favorites.length }}</div>
          <div class="stat-label">我的收藏</div>
        </div>
        <div class="stat-card" @click="$router.push('/trial')">
          <div class="stat-icon"><i class="el-icon-s-promotion"></i></div>
          <div class="stat-num">{{ trials.length }}</div>
          <div class="stat-label">试用申请</div>
        </div>
      </div>

      <!-- 功能入口 -->
      <div class="action-card">
        <div class="card-header">
          <h2><span class="bar"></span> 账户功能</h2>
        </div>
        <div class="card-body">
          <div class="action-grid">
            <div class="action-item" @click="$router.push('/trial')">
              <div class="action-icon"><i class="el-icon-s-promotion"></i></div>
              <div class="action-content">
                <div class="action-title">试用申请 <i class="el-icon-arrow-right"></i></div>
                <div class="action-desc">提交您感兴趣的产品试用申请，专人联系</div>
              </div>
            </div>
            <div class="action-item" @click="$router.push('/change-password')">
              <div class="action-icon"><i class="el-icon-key"></i></div>
              <div class="action-content">
                <div class="action-title">修改密码 <i class="el-icon-arrow-right"></i></div>
                <div class="action-desc">定期更换密码，保障账户安全</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 基本信息 -->
      <div class="info-card">
        <div class="card-header">
          <h2><span class="bar"></span> 基本信息</h2>
          <el-button type="primary" size="small" icon="el-icon-edit" @click="showEditDialog">
            完善个人信息
          </el-button>
        </div>
        <div class="card-body">
          <div class="info-grid">
            <div class="info-row" v-for="field in infoFields" :key="field.key">
              <div class="info-label">{{ field.label }}</div>
              <div class="info-value">{{ getFieldValue(field.key) }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 我的收藏 -->
      <!-- <div class="fav-card" v-loading="favLoading">
        <div class="card-header">
          <h2><span class="bar"></span> 我的收藏</h2>
          <span class="extra">共 {{ favorites.length }} 条</span>
        </div>
        <div class="card-body">
          <div class="fav-list" v-if="favorites.length > 0">
            <div class="fav-header">
              <div class="fav-col">名称</div>
              <div class="fav-col">网址</div>
              <div class="fav-col">标签</div>
              <div class="fav-col">说明</div>
              <div class="fav-col">操作</div>
            </div>
            <div class="fav-item" v-for="fav in paginatedFavorites" :key="fav.id">
              <div class="fav-col">
                <i :class="fav.type === 'site' ? 'el-icon-monitor' : 'el-icon-mobile-phone'" style="color: #667eea; margin-right: 6px"></i>
                {{ fav.name || '-' }}
              </div>
              <div class="fav-col">
                <a v-if="fav.url" :href="fav.url" target="_blank" rel="noopener">
                  {{ fav.url.replace(/^https?:\/\//, '') }}
                </a>
                <span v-else>--</span>
              </div>
              <div class="fav-col">
                <template v-if="fav.tags && fav.tags.length">
                  <el-tag size="mini" v-for="tag in fav.tags" :key="tag">{{ tag }}</el-tag>
                </template>
                <span v-else>--</span>
              </div>
              <div class="fav-col" :title="fav.desc">{{ fav.desc || '--' }}</div>
              <div class="fav-col">
                <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handleDeleteFav(fav)"></el-button>
              </div>
            </div>
          </div>
          <div class="empty" v-else>
            <i class="el-icon-inbox"></i> 暂无收藏
          </div>
          <div class="pagination" v-if="favorites.length > pageSize">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="favorites.length"
              :page-size="pageSize"
              :current-page.sync="currentPage"
            ></el-pagination>
          </div>
        </div>
      </div> -->
        </section>
      </div>
    </div>

    <!-- 编辑个人信息弹窗 -->
    <el-dialog title="完善个人信息" :visible.sync="editDialogVisible" width="480px">
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="80px">
        <el-form-item label="姓名" prop="realName">
          <el-input v-model="editForm.realName" maxlength="20" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editForm.email" maxlength="40" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="userInfo.mobile" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveProfile" :loading="saving">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCurrentUser,
  getUserInfo,
  setUserInfo,
  formatTime,
  daysBetween,
  getGreeting
} from '@/utils/auth'
import UserCenterSidebar from '@/components/UserCenterSidebar'

export default {
  name: 'Profile',
  components: {
    UserCenterSidebar
  },
  data () {
    const validateEmail = (rule, value, callback) => {
      if (value && !/^[\w.+-]+@[\w-]+(\.[\w-]+)+$/.test(value)) {
        callback(new Error('请输入正确的邮箱'))
      } else {
        callback()
      }
    }
    return {
      userInfo: {},
      favorites: [],
      trials: [],
      favLoading: false,
      currentPage: 1,
      pageSize: 10,
      editDialogVisible: false,
      saving: false,
      editForm: {
        realName: '',
        email: ''
      },
      editRules: {
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      },
      infoFields: [
        { key: 'realName', label: '姓名' },
        { key: 'mobile', label: '手机号' },
        { key: 'email', label: '邮箱' },
        { key: 'companyName', label: '所属公司' },
        { key: 'departmentName', label: '所属部门' },
        { key: 'createTime', label: '注册时间' },
        { key: 'roles', label: '所属角色' }
      ]
    }
  },
  computed: {
    avatarInitial () {
      return (this.displayName || 'U').slice(0, 1).toUpperCase()
    },
    displayName () {
      return this.userInfo.realName || this.userInfo.nickname || this.userInfo.username || this.userInfo.mobile || '用户'
    },
    greeting () {
      return getGreeting()
    },
    daysCount () {
      if (!this.userInfo.createTime) return 0
      return daysBetween(new Date(this.userInfo.createTime.replace(/-/g, '/')), new Date())
    },
    paginatedFavorites () {
      const start = (this.currentPage - 1) * this.pageSize
      return this.favorites.slice(start, start + this.pageSize)
    }
  },
  created () {
    this.$bus.$on('login-success', this.handleLoginSuccess)
    if (!this.checkLogin()) return
    this.getUserInfo()
    this.loadLocalData()
  },
  methods: {
    checkLogin () {
      const user = getCurrentUser()
      if (!user) {
        this.$bus.$emit('open-login')
        return false
      }
      this.userInfo = user
      return true
    },
    handleLoginSuccess () {
      if (!getCurrentUser()) return
      this.getUserInfo()
      this.loadLocalData()
    },
    getUserInfo () {
      this.$http({
        url: this.$http.adornUrl('/crmapi/p/user/getByUserCenter'),
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          const r = data.result || {}
          this.userInfo = {
            id: r.id,
            accountId: r.accountId,
            realName: r.realName || '',
            mobile: (r.loginAccount && r.loginAccount.mobile) || '',
            email: (r.loginAccount && r.loginAccount.email) || '',
            companyName: r.companyName || '',
            departmentName: r.departmentName || '',
            createTime: r.createTime || '',
            avatarUrl: r.avatarUrl || '',
            roles: (r.roleVos || []).map(v => v.name).join('/'),
            tenants: (r.tenantVos || []).map(v => v.name).join('/')
          }
          // 同步姓名/手机号等到底部导航使用的本地会话
          const session = getUserInfo() || {}
          setUserInfo({
            ...session,
            realName: this.userInfo.realName,
            mobile: this.userInfo.mobile,
            email: this.userInfo.email,
            companyName: this.userInfo.companyName
          })

          this.loadTrials()
        } else {
          this.$message.error((data && data.message) || '获取用户信息失败')
        }
      })
    },
    loadLocalData () {
      this.loadFavorites()
    },
    loadTrials () {
      if (!this.userInfo.mobile) return
      this.$http({
        url: this.$http.adornUrl('/crmapi/crm/clue/clueList'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 100,
          data: { telephone: this.userInfo.mobile }
        }
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          const result = data.result || {}
          this.trials = result.list || []
        }
      })
    },
    loadFavorites () {
      this.favLoading = true
      this.$http({
        url: this.$http.adornUrl('/crmapi/crm/favorite/list'),
        method: 'post',
        data: this.$http.adornData({
          data: { source: 'SUPPLY_CHAIN_SITE' },
          params: {}
        })
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          const result = data.result || {}
          this.favorites = (result.list || []).map(fav => {
            const site = fav.supplyChainSite || {}
            return {
              id: fav.id,
              type: 'site',
              name: site.name || fav.targetTitle || '',
              url: site.siteUrl || fav.targetUrl || '',
              tags: site.tagList || (site.tags ? site.tags.split(',').filter(t => t) : []),
              desc: site.description || fav.targetSubtitle || ''
            }
          })
        } else {
          this.$message.error((data && data.message) || '获取收藏列表失败')
        }
      }).finally(() => {
        this.favLoading = false
      })
    },
    formatTime (time) {
      return formatTime(time)
    },
    getFieldValue (key) {
      const value = this.userInfo[key]
      if (key === 'createTime') {
        return this.formatTime(value)
      }
      return value || '—'
    },
    showEditDialog () {
      this.editForm = {
        realName: this.userInfo.realName || '',
        email: this.userInfo.email || ''
      }
      this.editDialogVisible = true
    },
    handleSaveProfile () {
      this.$refs.editForm.validate(valid => {
        if (!valid) return

        this.saving = true
        this.$http({
          url: this.$http.adornUrl('/crmapi/p/user/updateUserInfo'),
          method: 'post',
          data: {
            id: this.userInfo.id,
            realName: this.editForm.realName,
            email: this.editForm.email
          }
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message.success('资料已更新')
            this.editDialogVisible = false
            this.getUserInfo()
          } else {
            this.$message.error((data && data.message) || '保存失败')
          }
        }).finally(() => {
          this.saving = false
        })
      })
    },
    handleDeleteFav (fav) {
      this.$confirm('确定删除该收藏吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/crmapi/crm/favorite/del'),
          method: 'post',
          data: this.$http.adornData({ id: fav.id })
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message.success('已删除')
            this.loadFavorites()
          } else {
            this.$message.error((data && data.message) || '取消收藏失败')
          }
        })
      }).catch(() => {})
    }
  },
  beforeDestroy () {
    this.$bus.$off('login-success', this.handleLoginSuccess)
  }
}
</script>

<style lang="scss" scoped>
.profile-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

.user-center {
  display: flex;
  gap: 20px;
}

.user-main {
  flex: 1;
  min-width: 0;
}

.user-hero {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

  .hero-avatar {
    width: 72px;
    height: 72px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #fff;
    font-weight: bold;
    margin-right: 20px;
    flex-shrink: 0;
  }

  .hero-info {
    flex: 1;
  }

  .hero-line {
    margin-bottom: 12px;

    .greeting {
      font-size: 16px;
      color: #666;
    }

    .name {
      font-size: 20px;
      color: #333;
      font-weight: 600;
    }
  }

  .hero-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    font-size: 13px;
    color: #999;

    i {
      margin-right: 4px;
    }

    b {
      color: #667eea;
    }
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;

  .stat-card {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    }

    .stat-icon {
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 12px;

      i {
        font-size: 24px;
        color: #ff9800;
      }
    }

    .stat-num {
      font-size: 28px;
      font-weight: 600;
      color: #333;
      margin-bottom: 4px;
    }

    .stat-label {
      font-size: 13px;
      color: #999;
    }
  }
}

.action-card, .info-card, .fav-card {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid #f0f0f0;

    h2 {
      font-size: 16px;
      color: #333;
      margin: 0;
      display: flex;
      align-items: center;

      .bar {
        width: 4px;
        height: 16px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 2px;
        margin-right: 10px;
      }
    }

    .extra {
      font-size: 13px;
      color: #999;
    }
  }

  .card-body {
    padding: 20px 24px;
  }
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  .action-item {
    display: flex;
    align-items: flex-start;
    padding: 16px;
    background: #f8f9fb;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: #f0f2f5;
      transform: translateX(4px);
    }

    .action-icon {
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      flex-shrink: 0;

      i {
        font-size: 22px;
        color: #ff9800;
      }
    }

    .action-content {
      flex: 1;

      .action-title {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        margin-bottom: 6px;

        i {
          font-size: 12px;
          margin-left: 4px;
          color: #999;
        }
      }

      .action-desc {
        font-size: 12px;
        color: #999;
        line-height: 1.5;
      }
    }
  }
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  .info-row {
    display: flex;
    padding: 12px 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }

    .info-label {
      width: 80px;
      color: #999;
      font-size: 13px;
      flex-shrink: 0;
    }

    .info-value {
      flex: 1;
      color: #333;
      font-size: 14px;
      word-break: break-all;
    }
  }
}

.fav-list {
  .fav-header, .fav-item {
    display: grid;
    grid-template-columns: 2fr 3fr 2fr 2fr 80px;
    gap: 16px;
    padding: 12px 0;
    align-items: center;
  }

  .fav-header {
    background: #f8f9fb;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 13px;
    color: #999;
    font-weight: 500;
  }

  .fav-item {
    border-bottom: 1px solid #f5f5f5;
    font-size: 14px;
    color: #333;

    &:hover {
      background: #f8f9fb;
    }

    &:last-child {
      border-bottom: none;
    }

    a {
      color: #667eea;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .el-tag {
      margin-right: 4px;
      margin-bottom: 2px;
    }
  }
}

.empty {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;

  i {
    font-size: 40px;
    color: #ddd;
    display: block;
    margin-bottom: 12px;
  }
}

.pagination {
  margin-top: 20px;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .user-center {
    flex-direction: column;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .action-grid {
    grid-template-columns: 1fr;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .fav-list {
    .fav-header {
      display: none;
    }

    .fav-item {
      grid-template-columns: 1fr;
      gap: 8px;
      padding: 16px;
      margin-bottom: 12px;
      background: #f8f9fb;
      border-radius: 8px;
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/profile.vue